export const MULTICALL3_ADDRESS = '0xca11bde05977b3631167028862be2a173976ca11';
